import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChart4"><Path d="M9.25 20.25V14.75H5.25C4.42157 14.75 3.75 15.4216 3.75 16.25V18.75C3.75 19.5784 4.42157 20.25 5.25 20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V10.75C9.25 9.92157 9.92157 9.25 10.75 9.25H14.75V20.25M14.75 20.25H18.75C19.5784 20.25 20.25 19.5784 20.25 18.75V5.25C20.25 4.42157 19.5784 3.75 18.75 3.75H16.25C15.4216 3.75 14.75 4.42157 14.75 5.25V20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChart4;
